import React from "react";
import "./App.css";
import "fontsource-roboto";
// Handle console logs
import "utils/dropConsole";
// Router
import { BrowserRouter } from "react-router-dom";
import RouterConfig from "./navigation/RouterConfig";
// Redux
import { Provider } from "react-redux";
import store, { persistor } from "./redux/store";
import {
  setAuthLoading,
  getUserByEmail,
  resetAuthDetails,
} from "redux/actions/userActions";
import { SET_AUTH } from "redux/CONSTANTS";
import { removeAuthorizationToken, getAuthorizationToken } from "utils";
// MUI Theme
import ThemeProvider from "@material-ui/styles/ThemeProvider";
import { createMuiTheme } from "@material-ui/core/styles";
// import { createTheme } from '@material-ui/core/styles'
import themeOptions from "./styles/muiTheme";
// Firebase
// import firebase from "firebase";
import { checkAuth } from "services/firebaseAuthentication";
// Componants
import Header from "./components/Header";
import { Container } from "@material-ui/core";
import Refresh from "components/Refresh";
import TestEnvironment from "components/TestEnvironment";
import { getDeviceLocation } from "services/map";
import {
  getLocations,
  saveDeviceCountryCode,
} from "./redux/actions/appActions";
import { RCProvider } from "providers/";
import  TranslationProvider  from "providers/TranslationProvider";
import { PersistGate } from "redux-persist/integration/react";

const theme = createMuiTheme(themeOptions);
let deviceCountry = null;
function App() {
  // eslint-disable-next-line no-undef
  console.log("ENV_APP_ENVIRONMENT=====", process.env.REACT_APP_ENV);
  console.log("ENV_DROP_CONSOLE=====", process.env.REACT_APP_DROP_CONSOLE);
  // LOAD EVENTS on APP LOAD.
  const dispatch = store.dispatch;
  // const [deviceLocation, setDeviceLocation] = useState(null);
  store.subscribe(() => {
    const { appConfig } = store.getState();
    deviceCountry = appConfig.deviceCountry;
  });
  const authLoading = () => {
    dispatch(setAuthLoading());
  };
  const getAuthDetails = (googleUser) => {
    dispatch(getUserByEmail(googleUser));
  };
  const removeAuthDetails = () => {
    removeAuthorizationToken();
    dispatch(resetAuthDetails());
  };
  // check authentication persistance
  checkAuth(getAuthDetails, removeAuthDetails, authLoading);

  // Check authentication before rendering the app.
  const token = getAuthorizationToken();
  console.log("USER TOKEN=====", token);
  if (token) {
    dispatch({ type: SET_AUTH });
  }

  // React.useEffect(() => {
  //   if (!deviceCountry)
  //     getDeviceLocation()
  //       .then((data) => {
  //         if (data && data[0]) {
  //           let deviceCountry = data[0];
  //           console.log("Location Data", deviceCountry);
  //           dispatch(saveDeviceCountryCode(deviceCountry));
  //           dispatch(getLocations(deviceCountry));
  //         }
  //       })
  //       .catch((e) => console.log("Location Data", e));
  // }, [deviceCountry]);

  // LOAD EVENTS on APP LOAD - end

  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <TranslationProvider />
          <RCProvider>
            <div className="App">
              <BrowserRouter>
                <Header />
                {process.env.REACT_APP_ENV !== "prod" && (
                  <div
                    className="imtime-testEnvironment"
                    style={{ marginBottom: 65 }}
                  >
                    <TestEnvironment />
                  </div>
                )}
                <Container maxWidth="false">
                  <RouterConfig />
                </Container>
              </BrowserRouter>
              <Refresh />
            </div>
          </RCProvider>
        </PersistGate>
      </Provider>
    </ThemeProvider>
  );
}

export default App;
